import { debounce } from "../utilities";

document.addEventListener('DOMContentLoaded', () => {
    bindCharacterCounters();
});

export function bindCharacterCounters() {
    document.querySelectorAll<HTMLElement>("[data-char-limit]").forEach(counter => {
        const target = document.querySelector<HTMLInputElement>(`#${counter?.getAttribute('data-target')}`);
        const ccAriaEvent = target?.getAttribute("char-count-aria-event");
        const ccEvent = target?.getAttribute('char-count-event');

        if (target === null) {
            console.debug('No character counter target defined.');
            return;
        }
        updateCharacterCount(counter, target);

        if (counter.hasAttribute("aria-live") && ccAriaEvent !== "true") {
            target.setAttribute("char-count-aria-event", "true");
            target.addEventListener('keyup', debounce(() => updateCharacterCount(counter, target), 1000));
        } else if (ccEvent !== 'true') {
            target.setAttribute('char-count-event', 'true');
            target.addEventListener('keyup', () => updateCharacterCount(counter, target));
        }
    });
}

function updateCharacterCount(counter: HTMLElement, target: HTMLInputElement) {
    const targetMaxLength = target.getAttribute('maxlength');
    const counterLimit = counter.getAttribute('data-char-limit');
    const charLimit = (counterLimit === "maxlength") ? Number.parseInt(targetMaxLength || '0') : Number.parseInt(counterLimit || targetMaxLength || '0');
    const charCount = target.value.length;

    counter.classList.add("text-gray-dark");
    if (charCount === 0) {
        counter.innerText = `${charLimit} characters allowed`
    }
    else {
        counter.innerText = `${charLimit - charCount} characters left`;
    }
}
